<template>
  <transition name="fade">
    <div v-if="isOpenedHandler" class="popup" @click.self="closePopup">
      <div class="popup__wrap">
        <div class="popup__close" @click="closePopup">
          <Controller type="close" />
        </div>
        <div :ref="popup_ref" class="popup__iframe">
          <div class="popup__spinner">
            <Spinner />
          </div>
          <iframe
            v-if="hasCMP" frameborder="0" allowfullscreen width="100%" height="100%" class="cmplazyload"
            src="about:blank" data-cmp-vendor="s30" :data-cmp-src="getVideoPopupVideoLinkHandler"
            :data-cmp-preview="cmp_size"
          ></iframe>
          <iframe
            v-else width="100%" height="100%" :src="getVideoPopupVideoLinkHandler" frameborder="0"
            allowfullscreen
          ></iframe>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
import Spinner from "@app_components/components/spinner/vue/Spinner.vue";
import Controller from "@static_promo_pages/common/components/redesign/controllers/vue/Controller.vue";
export default {
  name: "PopupVideo",
  components: {
    Controller,
    Spinner,
  },
  props: {
    videoId: {
      type: String,
      default: () => {
        return "";
      },
    },
    videoType: {
      type: String,
      default: () => {
        return "youtube";
      },
    },
    mode: {
      type: String,
      default: () => {
        return "self"; // "self" checks props, "store" check vuex store
      },
    },
    isOpened: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      cmp_size: "",
      popup_ref: "popup_video",
    };
  },
  computed: {
    hasCMP() {
      return !!window.__cmp;
    },
    isStoreMode() {
      return this.mode === "store";
    },
    getVideoPopupVideoLinkHandler() {
      return this.isStoreMode
        ? this.$store.getters["video_popup/getVideoPopupVideoLink"]
        : this.getVideoYouTubeLink;
    },
    isOpenedHandler() {
      return this.isStoreMode
        ? this.$store.getters["video_popup/getVideoPopupStatus"]
        : this.isOpened;
    },
    getVideoYouTubeLink() {
      return `https://www.youtube.com/embed/${this.videoId}?autoplay=1&rel=0&showinfo=0`;
    },
  },
  watch: {
    isOpened() {
      this.getCMPHeight();
      this.$nextTick(() => {
        if (this.hasCMP) {
          window.__cmp("checkBlocking");
        }
      });
    },
  },
  mounted() {
    window.addEventListener("resize", this.getCMPHeight);
    window.addEventListener("keydown", this.escHandler);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.getCMPHeight);
    window.removeEventListener("keydown", this.escHandler);
  },
  methods: {
    closePopup() {
      if (this.isStoreMode) {
        this.$store.commit("video_popup/closeVideoPopup");
      } else {
        this.$emit("popupClose");
      }
    },
    escHandler(e) {
      const key = e.key;

      if (key === "Escape") {
        this.closePopup();
      }
    },
    getCMPHeight() {
      if (!this.$refs[this.popup_ref]) return false;

      const popup_height = this.$refs[this.popup_ref].offsetHeight;
      this.cmp_size = `100%x${popup_height}`;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../styles/popup-video";
</style>
